import { Component } from 'preact'
import axios from 'axios'
import classNames from 'classnames'
import ContentCurationList from '../ContentCurationList'
import ForumContentCurationItem from './ForumContentCurationItem'
import ArticleIcon from '../../assets/icon-content-type-article'
import QuestionIcon from '../../assets/icon-content-type-question'
import AnswerIcon from '../../assets/icon-content-type-answer'
import DiscussionIcon from '../../assets/icon-content-type-discussion'
import IdeaIcon from '../../assets/icon-content-type-idea'
import Phrase from '../../../libs/translationsUtils/phrase'

export default class ForumContentCurationWrapper extends Component {
  constructor () {
    super()

    this.state = {
      collapsed: true,
      isOverflowVisible: false,
      data: []
    }
    this.topicCurationListEl = null

    this.setListMaxHeight = this.setListMaxHeight.bind(this)
    this.setOverflowVisible = this.setOverflowVisible.bind(this)
  }

  componentDidMount () {
    const sourceUrl = this.props.isKnowledgeBase
      ? '/knowledgeBase/getKnowledgeBaseTopics'
      : '/contentCuration/curatedTopics'

    axios.get(sourceUrl, {
      params: {
        forumId: this.props.forumId,
        category: this.props.forumId
      }
    })
      .then(response => {
        const localStorageCollapsed = window.localStorage.getItem('collapsedSticky') !== 'undefined' ? JSON.parse(window.localStorage.getItem('collapsedSticky')) : false

        this.setState({
          data: response.data.content,
          title: response.data.contentCurationTitle,
          enabled: this.props.isKnowledgeBase || response.data.enabled,
          showExpandButton: response.data.enabledCommunityList,
          collapsed: response.data.enabledCommunityList && localStorageCollapsed
        })
      })
  }

  componentDidUpdate () {
    this.toggleDropdown(this.state.collapsed, true)
    window.addEventListener('resize', this.setListMaxHeight, true)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.setListMaxHeight, true)
  }

  setListMaxHeight () {
    if (!this.topicCurationListEl || !this.topicCurationListEl.style) return
    this.topicCurationListEl.style.maxHeight = this.state.collapsed ? 0 : `${this.topicCurationListEl.scrollHeight}px`
  }

  toggleDropdown (collapsed, onMount = false) {
    if (!onMount) {
      this.setState({
        collapsed: !collapsed,
        isOverflowVisible: false
      })
    }

    this.setListMaxHeight()

    window.localStorage.setItem('collapsedSticky', JSON.stringify(this.state.collapsed))
  }

  setOverflowVisible () {
    this.setState({
      isOverflowVisible: true
    })
  }

  renderHeader () {
    const { isKnowledgeBase } = this.props
    const { data: stateData, collapsed, title, showExpandButton } = this.state
    const headerClassName = isKnowledgeBase ? 'topic-curation__header--knowledgeBase' : ''

    return (
      <div class={`topic-curation__header ${headerClassName}`}>
        <h4 class='topic-curation__widget-title'>{title} {`(${stateData.length})`}</h4>
        {showExpandButton &&
          <button
            className='topic-curation__widget-toggle'
            onClick={() => this.toggleDropdown(collapsed)}
            type='button'
          >
            <i className={classNames({
              'icon--auto-width': true,
              'icon--caret-up': !collapsed,
              'icon--caret-down': collapsed
            })}
            />
          </button>}
      </div>
    )
  }

  render (props, state) {
    const { cdn, showHeader, showAllLink, forumId, isKnowledgeBase, isParentKnowledgeBase } = props
    const { data: stateData, enabled, isOverflowVisible } = state
    const topicType = {
      question: <QuestionIcon />,
      article: <ArticleIcon />,
      answer: <AnswerIcon />,
      discussion: <DiscussionIcon />,
      idea: <IdeaIcon />
    }
    const overflowVisibleClassName = isOverflowVisible ? 'topic-curation-destination__container--overflowVisible' : ''

    if (!enabled || !stateData || !stateData.length) {
      return null
    }

    return (
      <section class={`topic-curation-destination__container ${overflowVisibleClassName} full-width`}>
        <div class='sitewidth'>
          {isKnowledgeBase && showHeader &&
            <a class='topic-curation__header-link' href={`/topic/overview?forumid=${forumId}`}>
              {this.renderHeader()}
            </a>}

          {!isKnowledgeBase && showHeader &&
            <div>
              {this.renderHeader()}
            </div>}
          <div onMouseEnter={this.setOverflowVisible}>
            <ContentCurationList ref={contentCurationList => { this.topicCurationListEl = contentCurationList.base }}>
              {
                stateData.filter((item, idx) => !(isKnowledgeBase && isParentKnowledgeBase && idx > 4))
                  .map((item, idx) => {
                    item.icon = topicType[item.type]
                    return <ForumContentCurationItem key={idx} {...item} cdn={cdn} idx={idx} categoryId={props.forumId} />
                  })
              }
            </ContentCurationList>
          </div>
          {isKnowledgeBase && showAllLink && stateData.length > 5 &&
            <a class='topic-curation__show-all-link' href={`/topic/overview?forumid=${forumId}`}>
              <div class='topic-curation__show-all-box'>
                <p class='topic-curation__show-all-text'>
                  <Phrase p='curated.content.view.all' />
                </p>
              </div>
            </a>}
        </div>
      </section>
    )
  }
}
